import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { blue } from '@mui/material/colors';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';

import { isMobile } from './nuiCommon/nuiDeviceDetector';
import text, {language, jurisdictionAlpha2} from "./nuiCommon/nuiText";
import {robotaxmakerTheme} from './nuiCommon/nuiRobotaxmakerTheme';

export default class NuiRegisterRobotax extends React.Component {
  constructor(props) {
    super(props);
    this.submitRegister = this.submitRegister.bind(this);
  }

  state = {
    inProgress: false,
    showRegisterConfirmDialog: false,
    registerFailed: false,
    passwordNotMatch: false,
    emptyFieldsMessage: "",
    login: '',
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    subscribed: true,
    password: '',
    repeatPassword: '',
    showPassword: false,
    hideSelf: false,
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleCheckboxChange = event => {
    this.setState({[event.target.name]: event.target.checked });
  };

  gotoHome() {
    this.setState({ hideSelf: true });
    this.forceUpdate();
    window.location.replace("https://robotaxmaker.com");
  }

  submitRegister(event) {
    if (event != null) {
      event.preventDefault();
    }

    this.setState({ passwordNotMatch: false });
    this.setState({ registerFailed: false });
    this.setState({ emptyFieldsMessage: ""});

    if (this.state['login'].trim() === "" ||
        this.state['password'].trim() === "" ||
        this.state['email'].trim() === "") {
      this.setState(
        { emptyFieldsMessage:
          text({"ru": "Следующие поля не могут быть пустыми:",
                "ua": "Наступні поля не можуть бути порожніми:",
                "en": "The following fields cannot be empty:",
                "es": "Los siguientes campos no pueden estar vacíos:"}) +
          (this.state['login'].trim() === ""
           ? " " + text({"ru": "Логин",
                         "ua": "Логін",
                         "en": "Login",
                         "es": "Acceso"})
           : "") +
          (this.state['password'].trim() === ""
           ? " " + text({"ru": "Пароль",
                         "ua": "Пароль",
                         "en": "Password",
                         "es": "Contraseña"})
           : "") +
          (this.state['email'].trim() === "" ? " Email" : "")});
      return;
    }

    if (this.state['password'] !== this.state['repeatPassword']) {
      this.setState({ passwordNotMatch: true });
      return;
    }

    this.setState({ inProgress: true });
    const config = { headers: { 'Content-Type': 'application/json',
                                'X-Requested-With': 'HttpRequest',
                                'Csrf-Token': 'nocheck'},
                     timeout: 0};
    const form = new FormData();
    form.append('login', this.state.login);
    form.append('password', this.state.password);
    form.append('firstName', this.state.firstName);
    form.append('lastName', this.state.lastName);
    form.append('middleName', this.state.middleName);
    form.append('email', this.state.email);
    form.append('serviceName', "robotaxmaker.com");
    // Registration jurisdiction from the subdomain the form is embedded on
    // (es.->ES, cz.->CZ; '' for the general portal). Server maps it to residence.
    form.append('residenceCountry', jurisdictionAlpha2());
    form.append('language', language);
    form.append('subscribed', this.state.subscribed);
    axios.post("/register", form, config)
      .then( (response) => {
        this.setState({ inProgress: false });
        if (response.status === 200) {
          this.setState({ showRegisterConfirmDialog: true });
        } else {
          this.setState({ registerFailed: true });
        }
      })
      .catch( (error) => {
        this.setState({ inProgress: false });
        this.setState({ registerFailed: true });
      });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    return (
      <ThemeProvider theme={robotaxmakerTheme}>
        <CssBaseline />
        {!this.state.inProgress
         ? <Box
             display={this.state.hideSelf ? "none" : "flex"}
             justifyContent="center"
             alignItems="center">
             <Box sx={isMobile()
                      ? {width: "100%"}
                      : {width: 500,
                         mt: 2}}>
               <Paper sx={{ width: 1 }}>
                 <Stack spacing={1}>
                   <Box
                     sx={{pt: 8}}
                     display="flex"
                     justifyContent="center"
                     alignItems="center">
                     <Avatar sx={{ bgcolor: robotaxmakerTheme.palette.primary.main }}>
                       <img src="/images/robotaxmaker_logo_white.svg"
                            height='30px'
                            width='30px'
                            alt='logo'/>
                     </Avatar>
                   </Box>
                   <Box
                     sx={{pt: 0.5}}
                     display="flex"
                     justifyContent="center"
                     alignItems="center">
                     <Typography component="h1" variant="h5">
                       {text({"ru": "Регистрация",
                              "ua": "Реєстрація",
                              "en": "Sign up",
                              "es": "Inscríbete"})}
                     </Typography>
                   </Box>
                   {this.state.registerFailed
                    ? <Alert severity="error">
                        {text({"ru": "Пользователь с таким логином или почтой уже зарегистрирован.",
                               "ua": "Користувач із таким логіном або поштою вже зареєстрований.",
                               "en": "A user with this username or email is already registered.",
                               "es": "Un usuario con este nombre de usuario o correo electrónico ya está registrado."})}
                      </Alert>
                    : ""}
                   {this.state.passwordNotMatch
                    ? <Alert severity="error">
                        {text({"ru": "Пароль не совпадает с подтверждением пароля.",
                               "ua": "Пароль не збігається з підтвердженням пароля.",
                               "en": "The password does not match the password confirmation.",
                               "es": "La contraseña no coincide con la confirmación de la contraseña."})}
                      </Alert>
                    : ""}
                   {this.state.emptyFieldsMessage !== ""
                    ? <Alert severity="error">
                        {this.state.emptyFieldsMessage}
                      </Alert>
                    : ""}
                   <FormControl
                     fullWidth
                     sx={{pt: 0.5, pl: 4, pr: 4}}>
                     <FormLabel htmlFor="login">
                       {text({"ru": "Логин",
                              "ua": "Логін",
                              "en": "Login",
                              "es": "Acceso"})}
                     </FormLabel>
                     <OutlinedInput
                       id="login"
                       type="login"
                       name="login"
                       autoComplete="email"
                       autoFocus
                       required
                       fullWidth
                       value={this.state.login}
                       onChange={this.handleChange('login')}>
                     </OutlinedInput>
                   </FormControl>
                   <FormControl
                     fullWidth
                     sx={{pt: 0.5, pl: 4, pr: 4}}>
                     <FormLabel htmlFor="firstName">
                       {text({"ru": "Имя",
                              "ua": "Ім'я",
                              "en": "Name",
                              "es": "Nombre"})}
                     </FormLabel>
                     <OutlinedInput
                       id="firstName"
                       type="firstName"
                       name="firstName"
                       autoComplete="firstName"
                       fullWidth
                       value={this.state.firstName}
                       onChange={this.handleChange('firstName')}>
                     </OutlinedInput>
                   </FormControl>
                   <FormControl
                     fullWidth
                     sx={{pt: 0.5, pl: 4, pr: 4}}>
                     <FormLabel htmlFor="lastName">
                       {text({"ru": "Фамилия",
                              "ua": "Прізвище",
                              "en": "Surname",
                              "es": "Apellido"})}
                     </FormLabel>
                     <OutlinedInput
                       id="lastName"
                       type="lastName"
                       name="lastName"
                       autoComplete="lastName"
                       fullWidth
                       value={this.state.lastName}
                       onChange={this.handleChange('lastName')}>
                     </OutlinedInput>
                   </FormControl>
                   <FormControl
                     fullWidth
                     sx={{pt: 0.5, pl: 4, pr: 4}}>
                     <FormLabel htmlFor="middleName">
                       {text({"ru": "Отчеcтво/Вторая фамилия",
                              "ua": "По батькові/Друге прізвище",
                              "en": "Middle name/Second surname",
                              "es": "Segundo apellido"})}
                     </FormLabel>
                     <OutlinedInput
                       id="middleName"
                       type="middleName"
                       name="middleName"
                       autoComplete="middleName"
                       fullWidth
                       value={this.state.middleName}
                       onChange={this.handleChange('middleName')}>
                     </OutlinedInput>
                   </FormControl>
                   <FormControl
                     fullWidth
                     sx={{pt: 0.5, pl: 4, pr: 4}}>
                     <FormLabel htmlFor="email">
                       Email
                     </FormLabel>
                     <OutlinedInput
                       id="email"
                       type="email"
                       name="email"
                       autoComplete="email"
                       fullWidth
                       value={this.state.email}
                       onChange={this.handleChange('email')}>
                     </OutlinedInput>
                   </FormControl>
                   <FormControlLabel sx={{pl: 2.5}}
                                     control={<Checkbox color="primary" />}
                                     label={text({"ru": "Подписаться на рассылку",
                                                  "ua": "Підпишіться на розсилку новин",
                                                  "en": "Subscribe to newsletters",
                                                  "es": "Suscríbete a boletines"})}
                                     value={this.state.subscribed}
                                     name="subscribed"
                                     onChange={this.handleCheckboxChange}>
                   </FormControlLabel>
                   <FormControl sx={{pl: 4, pr: 4, pt: 0}}>
                     <FormLabel htmlFor="password">
                       {text({"ru": "Пароль",
                              "ua": "Пароль",
                              "en": "Password",
                              "es": "Contraseña"})}
                     </FormLabel>
                     <OutlinedInput
                       margin="normal"
                       required
                       fullWidth
                       name="password"
                       type={this.state.showPassword ? 'text' : 'password'}
                       id="password"
                       value={this.state.password}
                       onChange={this.handleChange('password')}
                       endAdornment={
                         <InputAdornment position="end">
                           <IconButton
                             aria-label="toggle password visibility"
                             onClick={this.handleClickShowPassword}
                             onMouseDown={this.handleMouseDownPassword}>
                             {this.state.showPassword
                              ? <Visibility />
                              : <VisibilityOff />}
                           </IconButton>
                         </InputAdornment>}/>
                   </FormControl>
                   <FormControl sx={{pl: 4, pr: 4, pt: 1}}>
                     <FormLabel htmlFor="repeatPassword">
                       {text({"ru": "Повторите пароль",
                              "ua": "Повторити пароль",
                              "en": "Repeat password",
                              "es": "Repita la contraseña"})}
                     </FormLabel>
                     <OutlinedInput
                       margin="normal"
                       required
                       fullWidth
                       name="repeatPassword"
                       type={this.state.showPassword ? 'text' : 'password'}
                       id="repeatPassword"
                       value={this.state.repeatPassword}
                       onChange={this.handleChange('repeatPassword')}
                       endAdornment={
                         <InputAdornment position="end">
                           <IconButton
                             aria-label="toggle password visibility"
                             onClick={this.handleClickShowPassword}
                             onMouseDown={this.handleMouseDownPassword}>
                             {this.state.showPassword
                              ? <Visibility />
                              : <VisibilityOff />}
                           </IconButton>
                         </InputAdornment>}/>
                   </FormControl>
                   <Box sx={{pl: 4, pr: 4, pt: 2}}>
                     <Button
                       type="submit"
                       fullWidth
                       variant="contained"
                       color="primary"
                       onClick={this.submitRegister}>
                       {text({"ru": "Зарегистрироваться",
                              "ua": "Зареєструватися",
                              "en": "Sign up",
                              "es": "Inscríbete"})}
                     </Button>
                   </Box>
                   <Box sx={{pl: 4, pr: 4, pt: 2, pb: 3,
                             display: "flow"}}>
                     <Link component="button" variant="body2"
                           sx={{float: "right"}}
                           onClick={this.props.gotoLogin}>
                       {text({"ru": "У вас уже есть аккаунт? Войти",
                              "ua": "Вже маєте обліковий запис? Увійдіть в систему",
                              "en": "Already have an account? Sign in",
                              "es": "¿Ya tiene una cuenta? Iniciar sesión"})}
                     </Link>
                   </Box>
                 </Stack>
               </Paper>
             </Box>
           </Box>
         : <Box display='flex'
                justifyContent="center"
                alignItems="center"
                sx={{pt: 30}}>
             <CircularProgress size={90}/>
           </Box>}
      </ThemeProvider>
    );
  }
}
